<template>
  <div>
    <Head title="Dashboard" />
    <div class="relative">
      <div class="flex flex-col lg:flex-row justify-between items-center mb-4">
      </div>
      <Editor :data="$props.data"/>
    </div>
  </div>
</template>
<script>
import { Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Editor from '@/Pages/Dashboard/Editor'

export default {
  components: {
    Editor,
    Head,
  },
  props: {
    data: String,
  },
  layout: Layout,
  data() {
    return {
      form: {
        font: null,
      },
    }
  },
  methods: {

  },
}

</script>


